const c = (n) => Object.entries(n).filter(([t, e]) => e !== "" && e !== null && e !== void 0).map(([t, e]) => {
  const r = encodeURIComponent(t), o = Array.isArray(e) ? e.filter((s) => s !== "").map(encodeURIComponent).join(",") : encodeURIComponent(String(e));
  return `${r}=${o}`;
}).join("&"), a = (n) => {
  if (!n)
    return {};
  const t = n.includes("?") ? new URL(n, "https://example.com").search : n, e = new URLSearchParams(t), r = {};
  for (const [o, s] of e)
    r[o] = s.includes(",") ? s.split(",").map(decodeURIComponent) : decodeURIComponent(s);
  return r;
}, m = (n) => {
  const t = new URL(n).hash.slice(1), e = new URLSearchParams(t);
  return Object.fromEntries(e);
}, i = (n, t, e) => {
  const r = new URL(n);
  return r.searchParams.set(t, e), r.toString();
}, p = (n, t, e) => {
  const r = new URL(n);
  return r.searchParams.append(t, e), r.toString();
}, d = (n) => new URL(n).searchParams.toString(), h = (n, t = !0) => Object.fromEntries(
  Object.entries(n).filter(([e, r]) => r != null && (t || r !== "")).map(([e, r]) => Array.isArray(r) ? [e, r.join(",")] : [e, r])
);
export {
  p as addQuery,
  h as getQueryObjectFromObject,
  c as getQueryStringFromObject,
  d as getQueryStringFromURL,
  m as parseHash,
  a as parseQuery,
  i as updateQuery
};
